(function () {
    var userProfileInfo = {};

    angular.module('directives')
        .directive('hHeaderUserIcon', ['hUser', 'hmapService', '$rootScope', 'socialReferralSettings','brandServices', function(hUser, hmapService, $rootScope, socialReferralSettings, brandServices) {
            return {
                restrict: 'E',
                link: function(scope) {
                    scope.user = hUser.data.user;
                    scope.isEmployeeReferralListsEnabled = false;
                    var activeBrand = hmapService.getActiveBrand();
                    scope.canAccessLiveSchedule = false;

                    var checkEmployeeReferralListsService = function(activeBrand){
                        socialReferralSettings.isEmployeeReferralListsOnGPEnabled(activeBrand).then(function (res) {
                            scope.isEmployeeReferralListsEnabled = res;
                        });
                    };

                    var getAcademyRedirectionLink = function() {
                        UserAPI.getAcademyLink()
                            .then(function(res) {
                                scope.academyRedirectionLink = res['redirection_link'];

                            })
                            .catch(function (err) {
                                console.error(err && err.data);
                            })
                            .finally(function () {
                            scope.$digest();
                        });
                    };

                    if(hUser.isLoggedIn()) {
                        if(!userProfileInfo[scope.user.id]) {
                            MemberAPI.getProfile(scope.user.id).then(function (result) {
                                userProfileInfo[scope.user.id] = result;
                                scope.profileInfo = userProfileInfo[scope.user.id];

                                setTimeout(function() {
                                    scope.$digest();
                                }, 1);
                            });
                        } else {
                            scope.profileInfo = userProfileInfo[scope.user.id];
                        }
                        checkEmployeeReferralListsService(activeBrand)
                        brandServices.check(brandServices.SERVICES.HARRI_ACADEMY, hUser.getEntryMode().brand_id)
                            .then(function (res) {
                                if(res) {
                                    getAcademyRedirectionLink();
                                }
                            });
                        brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, hUser.getEntryMode().brand_id, true)
                            .then(function(isTeamSchedulingEnabled) {
                                if (isTeamSchedulingEnabled) {
                                    LiveScheduleAPI.checkIfBrandHasAvailableShiftsEmailsService(hUser.getEntryMode().brand_id)
                                        .then(function (availableShiftsEnabled) {
                                            scope.canAccessLiveSchedule = availableShiftsEnabled;
                                        });
                                }
                            });
                    }

                    $rootScope.$on('$locationChangeSuccess', function () {
                        var activeBrand = hmapService.getActiveBrand();
                        brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, hUser.getEntryMode().brand_id, true)
                            .then(function(isTeamSchedulingEnabled) {
                                if (isTeamSchedulingEnabled) {
                                    LiveScheduleAPI.checkIfBrandHasAvailableShiftsEmailsService(hUser.getEntryMode().brand_id)
                                        .then(function (availableShiftsEnabled) {
                                            scope.canAccessLiveSchedule = availableShiftsEnabled;
                                        });
                                }
                            });
                        checkEmployeeReferralListsService(activeBrand)
                    });

                },

                templateUrl: '../hmodules/directives/h-header-user-icon/h-header-user-icon.directive.html',
            };
        }]);
})();